<template>
  <div>
    <div class="max-w-5xl mx-auto space-y-16">
      <div class="flex items-center justify-between">
        <h4 class="text-indigo-500 capitalize">
          {{ $te('packageEditions') ? $t('packageEditions') : 'packageEditions' }}
        </h4>
        <RouterLink
          :to="{ name: 'admin.products.packages.package.packageEditions.create' }"
          class="btn btn-brand px-6 capitalize"
        >
          {{ $te('newPackageEdition') ? $t('newPackageEdition') : 'newPackageEdition' }}
        </RouterLink>
      </div>
      <!--
        List container
      -->
      <div class="flex flex-wrap -mx-4">
        <div
          v-for="packageEdition in packageEditions"
          :key="packageEdition.id"
          class="w-1/3 px-4 mb-8"
        >
          <!--
            Package Edition
          -->
          <PackageEditionSingle
            :package-edition="packageEdition"
            :package-items="packageItems"
            :processing="processing.indexOf(packageEdition.id) !== -1"
            @submit="doPackageEditionUpdate"
            @delete="doPackageEditionDelete"
          />
        </div>
      </div>
      <div>
        <RouterView name="modal" />
      </div>
    </div>
  </div>
</template>

<script>
import { packageEditionMethods, packageEditionComputed } from '@/store/adminHelper';
import PackageEditionSingle from '@/components/PackageEdition/PackageEditionSingle.vue';

export default {
  name: 'PackageEditionList',
  components: {
    PackageEditionSingle,
  },
  props: {
    packageId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    fetching: false,
    processing: [],
    checked: false,
  }),
  computed: {
    ...packageEditionComputed,
  },
  created() {
    this.doGetPackageEditions();
  },
  destroyed() {
    this.setIds([]);
    this.setMeta(null);
    this.setLinks(null);
  },
  methods: {
    ...packageEditionMethods,
    doGetPackageEditions(queryParams = {}) {
      const { packageId: productId } = this;
      this.fetching = true;
      this.getPackageEditions({ productId, queryParams })
        .then(() => {
          this.fetching = false;
        })
        .catch(() => {
          this.fetching = false;
        });
    },
    doPackageEditionUpdate(payload) {
      this.processing.push(payload.packageEditionId);
      this.updatePackageEdition(payload)
        .then(() => {
          this.processing = [...this.processing.filter((id) => id !== payload.packageEditionId)];
        })
        .catch(() => {
          this.processing = [...this.processing.filter((id) => id !== payload.packageEditionId)];
        });
    },
    doPackageEditionDelete(packageEditionId) {
      this.processing.push(packageEditionId);
      this.deletePackageEdition({ packageEditionId })
        .then(() => {
          this.processing = [...this.processing.filter((id) => id !== packageEditionId)];
        })
        .catch(() => {
          this.processing = [...this.processing.filter((id) => id !== packageEditionId)];
        });
    },
  },
};
</script>
